import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import HttpClient from 'services/HttpClient';
import {inject} from 'mobx-react';

const RECOVERY_TOKEN_CREATE = '/api/v1/passwords_recovery';

@withRouter
@inject('alertStore')
export default class ResetFormEmail extends Component {
  state = {
    errors  : {},
    formData: {
      email: ''
    }
  };

  handleChange = e => {
    let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
    this.setState({formData: newState});
  };

  handleSubmit = e => {
    e.preventDefault();
    new HttpClient().post(RECOVERY_TOKEN_CREATE, this.state.formData).then(() => {
      this.handleResponse();
    }).catch(() => {
      this.handleError();
    })
  };

  handleResponse = () => {
    this.props.alertStore.success('Check your email');
    this.props.history.push(`/emailsent/${this.state.formData.email}`);
  };

  handleError = () => {
    const error = 'The email address you entered has not been registered';
    this.props.alertStore.success(error);
    this.setState({formData: {email: ''}})
  };

  render() {

    return (
      <div className="form-wrapper">
        <div className="form-container">
          <div className="form-header-wrap col-12 col-md-6">
            <div className="subtitle">Password reset</div>
            <div className="label">Enter your email address that you used to register. We will send
              you an email
              with a link to reset your password
            </div>
          </div>
          <div className="form-content  col-4">
            <form className="reset-form" onSubmit={this.handleSubmit}>
              <div className="input-wrap">
                <TextField
                  name="email"
                  className='email'
                  floatingLabelText="Email"
                  type="email"
                  value={this.state.formData.email}
                  onChange={this.handleChange}
                />
              </div>

              <div className="button-set">
                <button className="btn blue rounded submit-btn" type="submit">Send</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/modules/auth/containers/ResetFormEmail.js